// 保存依赖信息的meta的key值
export const CLASS_CONSTRUCTOR_DEPS = 'di:ctor_deps';
export const PROPS_DEPS = 'di:props_deps';
export const POST_CONSTRUCTOR = 'di:post_constructor';
//# sourceMappingURL=metadata-keys.js.map